/* eslint-disable import/no-webpack-loader-syntax */
import { getAIPageContextInstance } from '@/utils/global/api';
import logger from '@/utils/logger';
import dts from '!!raw-loader!./wuji-upload.d.ts';
export async function getTypeDefinitions() {
    logger.log(dts);
    return dts;
}
export default class WujiUpload {
    uploadImage = (file, filePath, cosId) => {
        const w = getAIPageContextInstance();
        return w.uploadImage(file, filePath, cosId);
    };
    uploadFile = (file, filePath, cosId) => {
        const w = getAIPageContextInstance();
        return w.uploadFile(file, filePath, cosId);
    };
    // 支持 import upload from '@wujibase/wuji-upload' 的形式
    get default() {
        return this;
    }
}
